// extracted by mini-css-extract-plugin
module.exports = {"content":"src-layouts-SiderLayout-module__content--3ClP3"};